import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { saveAs } from 'file-saver';

import { HEADER_EXTEND_KEYS } from '@core/constants/header-extend.constant';

import { CrudBaseService } from '../crud.service';
import { NabAbaDownload, Withdraw } from '../models';
import { HttpHelper } from '../../helpers';


@Injectable()
export class WithdrawService extends CrudBaseService<Withdraw> {
    constructor(httpClient: HttpClient) {
        super('/withdrawal', httpClient);
    }

    validate(id: string): Observable<any> {
        return this.httpClient.get(`${this.basePath}/${id}/validate`).pipe(map((res: any) => res.data));
    }

    approve(id: string): Observable<any> {
        return this.httpClient.patch(
            `${this.basePath}/${id}/approve`,
            {
                data: { approved: true }
            },
            {
                headers: {
                    [HEADER_EXTEND_KEYS.NOT_SHOW_DEFAULT_ALERT_ERROR]: 'true'
                }
            }
        );
    }

    deny(id: string): Observable<any> {
        return this.httpClient.patch(`${this.basePath}/${id}/denied`, {
            data: { denied: true }
        });
    }

    download(filterParams: any): Observable<Withdraw[]> {
        return this.httpClient
            .get<Withdraw[]>(`${this.basePath}/download`, {
                params: HttpHelper.objectToHttpParams({ ...filterParams })
            })
            .pipe(map((res: any) => res && res.data));
    }

    downloadNAB(widthdrawId: string): Observable<NabAbaDownload> {
        return this.httpClient
            .get(`${this.basePath}/generate_nab_aba_file/${widthdrawId}`)
            .pipe(
                map((res: any) => res && res.data),
                tap((nabFile: NabAbaDownload) => {
                    const blob = new Blob([nabFile.file_content], { type: 'text/text;charset=utf-8'});
                    saveAs(blob, nabFile.file_name);
                })
            )
    }
}
